import Vue from 'vue'
import {
    CURRENT_CUST_INFO,
    ESP_CUST_INFO,
    ESPCI_IS_NEXT,
    ID,
    OWNER,
    MOBILE,
    ESP_SP_BUSINES,
    ESP_SP_TRACK_RECORD,
    ESP_SP_CALCULATE_PRICE,
    CONDITION,
    TRACK_RECORD_CONDITION,
} from '@/store/mutation-types'

const accounts = {
    state : {
        //主题
        // theme: "dark",
        //当前客户信息
        currentCustInfo: {
            id: '',
            owner: 'defaultOwner',
            mobile: 'defaultMobilel'
        },
        //电销业务客户信息
        ESPCustInfo: {
            id: '',
            owner: 'defaultOwner',
            mobile: 'defaultMobilel'
        },
        ESPCIisNext: false,
        id: 0,
        owner: 'xiao',
        mobile: '',
        //电销模式加载样式状态管理
        spBusiness: false,
        spTrackRecord: false,
        spCalculatePrice: false,
        //客户资料查询条件
        condition: {
            where: [],
            orderby: '',
            order: '',
            page: ''
        },
        //客户详细资料中的跟踪记录
        trackRecordCondition:{
            where: [],
            orderby: '',
            order: '',
            page: ''
        }
    },
    mutations: {
        CURRENT_CUST_INFO: (state, currentCustInfo) => {
            state.currentCustInfo = currentCustInfo
            Vue.ls.set(CURRENT_CUST_INFO, currentCustInfo)
        },
        ESP_CUST_INFO: (state, ESPCustInfo) => {
            state.ESPCustInfo = ESPCustInfo
        },
        ESPCI_IS_NEXT:(state, ESPCIisNext) => {
            state.ESPCIisNext = ESPCIisNext;
        },
        ID:(state, id) => {
            state.id = id;
        },
        OWNER:(state, owner) => {
            state.owner = owner;
        },
        MOBILE:(state, mobile) => {
            state.mobile = mobile;
        },
        ESP_SP_BUSINESS:(state, spBusiness) => {
            state.spBusiness = spBusiness;
        },
        ESP_SP_TRACK_RECORD:(state, spTrackRecord) => {
            state.spTrackRecord = spTrackRecord;
        },
        ESP_SP_CALCULATE_PRICE:(state, spCalculatePrice) => {
            state.spCalculatePrice = spCalculatePrice;
        },
        CONDITION:(state, { where = [], orderby = '', order = '', page = '' }) => {
            state.condition = {
                where,
                orderby,
                order,
                page
            }
        },
        TRACK_RECORD_CONDITION:(state, { where = [], orderby = '', order = '', page = '' }) => {
            state.trackRecordCondition = {
                where,
                orderby,
                order,
                page
            }
        },
    },
    actions: {
        setCurrentCustInfo: ({ commit }, currentCustInfo) => {
            commit('CURRENT_CUST_INFO', currentCustInfo)
        },
        setESPCustInfo: ({ commit }, ESPCustInfo) => {
            commit('ESP_CUST_INFO', ESPCustInfo)
        },
        setESPCIisNext: ({ commit }, ESPCIisNext) => {
            commit('ESPCI_IS_NEXT', ESPCIisNext)
        },
        setID: ({ commit }, id) => {
            commit('ID', id)
        },
        setOwner: ({ commit }, owner) => {
            commit('OWNER', owner)
        },
        setMobile: ({ commit }, mobile) => {
            commit('MOBILE', mobile)
        },
        setSpBusiness: ({ commit }, spBusiness) => {
            commit('ESP_SP_BUSINESS', spBusiness)
        },
        setSpTrackRecord: ({ commit }, spTrackRecord) => {
            commit('MOBILE', spTrackRecord)
        },
        setSpCalculatePrice: ({ commit }, spCalculatePrice) => {
            commit('ESP_SP_CALCULATE_PRICE', spCalculatePrice)
        },
        setCondition: ({ commit }, condition) => {
            commit('CONDITION', condition)
        },
        setTrackRecordCondition: ({ commit }, trackRecordCondition) => {
            commit('TRACK_RECORD_CONDITION', trackRecordCondition)
        },
    }
}

export default accounts


// WEBPACK FOOTER //
// ./src/store/modules/accounts.js